/**
 * Picking a date should mean scheduling. Without this, a writer who goes
 * straight to the date field and saves gets whatever radio happened to be
 * selected -- publishing immediately, or on a draft, discarding the date they
 * just typed. Progressive enhancement: the radios work on their own, this only
 * saves a step.
 */
export function selectPublishModeOnDateEntry(
  root: ParentNode = document,
): void {
  const field = root.querySelector<HTMLInputElement>(
    "[data-selects-publish-mode]",
  );
  if (!field) return;

  const mode = field.dataset.selectsPublishMode;
  const radio = root.querySelector<HTMLInputElement>(
    `input[type="radio"][value="${mode}"]`,
  );
  if (!radio) return;

  const select = () => {
    if (!radio.checked) radio.checked = true;
  };

  field.addEventListener("input", select);
  field.addEventListener("focus", select);
}
